import {Api} from "./Api";
import {StichwortData, StichwortResult} from "./structs/StichwortData";
import 'corejs-typeahead';

export class Stichwort {
    static autoComplete(str: string, callback?: (data: StichwortData) => void) {
        Api.stichwortData(str, data => {
            if (callback) callback(data);
        });
    }

    static init() {
        const $inputs = $("input[name='location'], #header-searchbar, #search-form-xs input[type='text']");
        if ($inputs.length > 0 && typeof ($inputs as any).typeahead === "function") {
            ($inputs as any).typeahead({highlight: true, minLength: 1}, {
                name: 'autocomplete',
                limit: 10,
                display: function (item: StichwortResult) {
                    return item.name;
                },
                source: function (query: string, syncResults: Function, asyncResults: Function) {
                    Stichwort.autoComplete(query, function (data: StichwortData) {
                        asyncResults(data.results);
                    });
                }, templates: {
                    suggestion: function (item: StichwortResult) {
                        return '<div>' + item.name + '</div>';
                    }
                }
            }).bind('typeahead:select', function (ev: any, item: StichwortResult) {
                if (item.url) {
                    window.location.href = item.url;
                }
            });
        }
    }
}
